import type React from 'react'
import { useState } from 'react'
import { Spinner } from './Spinner'

interface ImagePreloaderProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt: string
  className: string
}

export function ImagePreloader({
  src,
  alt,
  className,
  onLoad,
  onError,
  ...rest
}: ImagePreloaderProps) {
  const [isLoaded, setIsLoaded] = useState(false)
  const [hasError, setHasError] = useState(false)

  const handleLoad: React.ReactEventHandler<HTMLImageElement> = (event) => {
    setIsLoaded(true)
    setHasError(false)
    onLoad?.(event)
  }

  const handleError: React.ReactEventHandler<HTMLImageElement> = (event) => {
    setHasError(true)
    setIsLoaded(false)
    onError?.(event)
  }

  return (
    <div className={`relative ${className}`}>
      {!isLoaded && !hasError && (
        <div className="absolute inset-0 flex items-center justify-center bg-neutral-100 dark:bg-neutral-800">
          <Spinner size="sm" label={`Loading ${alt}`} />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
        className={`block ${className} ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        }`}
        {...rest}
      />
    </div>
  )
}
